import react from "react";
function Experience() {
    return (
        <div className="experience">
            <div className = "experience-card">
            <h2 className="experience-title">Experience</h2>
            <p className="experience-item">Mobile Developer Intern - SOS 42  (14 January 2026-Present)</p>
            <p className="experience-item">Flutter Developer Intern - GreenCreon LLP Corporation (25th August 2025 - 25th December 2025)</p>
            </div>
        </div>
    );
}

export default Experience;